
import { ref, watch } from 'vue'

import { fetchData } from '../utils/fetch'

import zipCode from './zip-code'

const payload = ref( { ready: false } )

watch( zipCode, async () => {

  payload.value = await fetchData( zipCode.value )

} )

export default payload